module.exports = __webpack_public_path__ + "img/trading.60cebfaa-71c912fd.c09653cd.svg";